module.exports = __webpack_public_path__ + "static/media/avatar.b638ed01.png";